<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate">Buscar acto</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'Registro Civil' }, { label: 'Buscar acto' }]" />
    </div>
  </section>

  <section wrapper>
    <p-tabView [activeIndex]="0">
      <p-tabPanel tabindex="0" header="Buscar Acto">
        <page-buscar-acto />
      </p-tabPanel>

      <p-tabPanel tabindex="1" header="Ingresar externo" *showForRoles="['GESTOR']">
        <page-externos />
      </p-tabPanel>
    </p-tabView>
  </section>
</backbone>
